import React from 'react'

export const Tabs = ({ areas = [], currentStep = 0, onChange }) => {
    return (
        <div className={"h-[60px] flex items-center gap-2 overflow-x-auto"}>
            {areas.map((area, index) => {
                const isCurrent = currentStep === index;
                return (
                    <div
                        key={`tab-${index}`}
                        className={`px-4 pb-2 flex justify-center items-center border-b-[2px] cursor-pointer  ${isCurrent ? "border-primaryTwo" : "border-[#E6E6E6]"}`}
                        onClick={() => onChange(index)}
                    >
                        {area.sectionName}
                    </div>
                )
            })}
        </div>
    );
};

export default Tabs